import { Card, TableData } from '@utilities';

interface IncidenceRateCardProps {
  overall?: boolean;
}

const IncidenceRateCard = ({ overall }: IncidenceRateCardProps) => {
  return (
    <Card>
      <>Incidence Rate by Segment</>
      {overall ? (
        <div>
          <b>94.1%</b> <i>(435 completes / 462 total)</i>
        </div>
      ) : (
        <>
          <TableData
            columns={[
              { accessor: 'segment', Header: 'Segment' },
              { accessor: 'completes', Header: 'Completes' },
              { accessor: 'total', Header: 'Total' },
              { accessor: 'incidence', Header: 'Incidence Rate' },
            ]}
            data={[
              { completes: 234, incidence: '93.6%', segment: 'General Population', total: 250 },
              { completes: 201, incidence: '94.4%', segment: 'Test Shoppers', total: 213 },
            ]}
          />
        </>
      )}
    </Card>
  );
};

export default IncidenceRateCard;
